<!------------------------------------------------------------------------------
  - Copyright (c) 2024. dnote.ai
  -
  - @project DNOTE.AI-Frontend
  - @author dnote.ai
  - @copyright Dnote.ai All rights reserved
  ----------------------------------------------------------------------------->

<template>
	<div class="d-block position-relative">
		<h5 class="my-0">{{ titleText }}</h5>
	</div>
</template>


<script>
	export default {
		name : "HeaderTitle",
		props: {
			titleText: {
				required: true,
				default(){
					return null;
				}
			},
   
		}
	}
</script>

<style scoped lang="scss">

</style>